import { render, staticRenderFns } from "./select-region.vue?vue&type=template&id=5bfef04c&"
import script from "./select-region.vue?vue&type=script&lang=js&"
export * from "./select-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports